export const categories = [
  // Nourriture & Boissons
  'Tous',
// categories.js


  'Atiéké',
  'Bijoux',
  'Bissap',
  'Boissons',
  'Chaussures',
  'Coussins',
  'Crêpes',
  'Dêguê',
  'Draps',
  'Fournitures électroniques',
  'Fournitures scolaire',
  'Gâteaux',
  'Gel de douche',
  'Glaçons',
  'Jus',
  'Pain',
  'Parfums',
  "Plaquettes d'œufs",
  'Poissons frais',
  'Placali',
  'Sacs',
  'Savon',
  'Serviettes',
  'Vêtements',
  'Accessoires divers',



  'Autres'
];
